import { object, string } from "yup";

export const getValidationSchema = (t) => object().shape({});

export const getResetPasswordInputs = (t) => [
  {
    name: "email",
    label: t("resetPassword.fields.emailLabel"),
    type: "email",
    placeholder: t("resetPassword.fields.emailPlaceholder"),
  },
  {
    name: "newPassword",
    label: t("resetPassword.fields.newPasswordLabel"),
    type: "password",
    placeholder: t("resetPassword.fields.newPasswordPlaceholder"),
  },
  {
    name: "confirmPassword",
    label: t("resetPassword.fields.confirmPasswordLabel"),
    type: "password",
    placeholder: t("resetPassword.fields.confirmPasswordPlaceholder"),
  },
];
